import {
  CreatePaymentMethod,
  CreatePurchase,
  GetDetailResponse,
  MomoPayment,
  Purchase,
  ZaloPayment,
} from "@app/types";
import { BookMediaType } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _PurchaseService {
  public createPurchase(createPurchase: CreatePurchase) {
    return HttpService.post<GetDetailResponse<Purchase>>(
      "/user/api/v1/purchase",
      {
        body: { ...createPurchase },
      }
    );
  }

  public createMomoPayment(createPaymentMethod: CreatePaymentMethod) {
    return HttpService.post<GetDetailResponse<MomoPayment>>(
      "/user/api/v1/momo",
      {
        body: { ...createPaymentMethod },
      }
    );
  }

  public createZaloPayment(createPaymentMethod: CreatePaymentMethod) {
    return HttpService.post<GetDetailResponse<ZaloPayment>>(
      "/user/api/v1/zalo-pay",
      {
        body: { ...createPaymentMethod },
      }
    );
  }

  public purchaseBookByMediaType(bookId: number, mediaType: BookMediaType) {
    return HttpService.post<GetDetailResponse<{ message: string }>>(
      `/user/api/v4/books/${bookId}/purchase`,
      {
        body: { mediaType },
      }
    );
  }
}

const PurchaseService = new _PurchaseService();

export default PurchaseService;
